import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocationStrategy } from '@angular/common';
import { FormGroup, FormControl} from '@angular/forms';

import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/shared/format-datepicker';

@Component({
  selector: 'add-paciente',
  templateUrl: './add-paciente.component.html',
  styleUrls: ['./add-paciente.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class AddPacienteComponent implements OnInit, OnDestroy {

  public _paciente: any;
  @Input() set paciente(val: any) {
    this._paciente = val;
    this.checkEditPatientValues();
}

  @Input() public readable: boolean;
  @Output() addPacienteEvent = new EventEmitter();

  public  addCitizenForm: FormGroup;

  public error = false;
  public cargado = false;
  public editando = false;
  private querySubscription;
  private original: any;
  errorMessage: String = '';
  dataLoading = false;
  savedChanges = false;
  showform = false;
  showError = false;
  instituciones;
  institution;
  ide;
  lugares;
  guardar = true;
  options;
  place;
  diagnosis;
  estados;
  estudios; estudios1;
  ciudadano;
  idioma;
  usuarioActivo;
  admin;
  institucionesFinal;
  ano; dateDay; month; fecha; fecha1; ano1; dateDay1; month1;
  hasError = false;
  checkDiagnosisFields = false;
  checkDiagnosisCaregiverFields = false;
  checkVitalSignsFields = false;
  checkIntegridadePeleFields = false;
  isCollaborator = false;

  /*for age calculation*/

  public evalDateControl = new FormControl('');
  public birthDateControl = new FormControl('');
  public ageControl = new FormControl('');


  name = 'Angular';
  value: any;


  constructor(private translate: TranslateService, private backendService: BackendService, private _route: Router, private locationStrategy: LocationStrategy) {
    this.translate.addLangs(['es', 'pt']);
    this.institucionesFinal = [];
    this.instituciones = [];
    this.preventBackButton();
  }

  finalizar(id_paciente: number, number_paciente: number) {
    // emitir un evento Output
    console.log('finalizando');
    this.addPacienteEvent.emit({'id': id_paciente, 'number': number_paciente});
  }

  preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      this.finalizar(null, null);
    });
  }


  ngOnInit() {
    console.log('Cargado add-paciente.component.ts');
    console.log('Usuario para editar (si es null, estás añadiendo)');
    console.log(this._paciente);

    this.monitoringAgeRelatedDatesChanges();

    this.isCollaborator = (window.localStorage.getItem('selected_view') === 'collaborator');


    console.log('Paciente inicial');
    console.log(this._paciente);
    console.log(this.original);

    const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    if (isSafari) { alert('You are using safari, it is possible that the form does not work correctly, please try with another browser'); }

    if (localStorage.length <= 0) {
        this._route.navigate(['../login']);
    } else {
        if (localStorage.getItem('token') == null) {
            this._route.navigate(['../login']);
        } else {
            this.showform = true;
            this.usuarioActivo = window.localStorage.getItem('entidad');
            this.admin = window.localStorage.getItem('admin');
            this.getInstitution();
            this.getPlaces();
            this.idioma = window.localStorage.getItem('idioma');
            this.sleep(50).then(() => {
                document.getElementById('inputNumber').focus();

            });

            if (localStorage.getItem('idioma') === 'es') {
            this.options = [
                {
                  id: 'Masculino',
                  value: '0'
                },
                {
                  id: 'Femenino',
                  value: '1'
                },
              ];
              this.diagnosis = [
                {
                  id: 'Neoplasias (tumores)',
                  value: '0'
                },
                {
                  id: 'Trastornos de la sangre y de los órganos hematopoyéticos',
                  value: '1'
                },
                {
                    id: 'Enfermedades del sistema nervioso',
                    value: '2'
                },
                {
                    id: 'Enfermedades del aparato circulatorio',
                    value: '3'
                },
                {
                    id: 'Enfermedades del aparato respiratorio',
                    value: '4'
                },
                {
                    id: 'Enfermedades del aparato digestivo',
                    value: '5'
                },
                {
                    id: 'Trastornos de la piel y del tejido subcutáneo',
                    value: '6'
                },
                {
                    id: 'Malformaciones congénitas, deformidades y anomalías cromosómicas',
                    value: '7'
                },
                {
                    id: 'Enfermedades del sistema osteomuscular',
                    value: '8'
                },
                {
                    id: 'Enfermedades del aparato genitourinario',
                    value: '9'
                },

                {
                    id: 'Enfermedades endocrinas, nutricionales y metabólicas',
                    value: '10'
                },

                {
                    id: 'Trastornos mentales y de comportamiento',
                    value: '11'
                },

                {
                    id: 'Sem qualquer patologia',
                    value: '12'
                },

              ];
              this.estados = [
                {
                  id: 'Soltero',
                  value: '0'
                },
                {
                  id: 'Casado',
                  value: '1'
                },
                {
                    id: 'Viudo',
                    value: '2'
                },
                {
                    id: 'Divorciado',
                    value: '3'
                },
              ];
              this.estudios = [
                {
                  id: 'Não frequentou a escola e não sabe ler nem escrever',
                  value: '0'
                },
                {
                  id: 'Não frequentou a escola, mas sabe ler e escrever',
                  value: '1'
                },
                {
                    id: 'Frequentou a escola mas não frequentou o ensino superior',
                    value: '2'
                },
              ];

              this.estudios1 = [
                {
                    id: 'Completó nievel de enseñanza superior',
                    value: '3'
                },
                ];

              }
            if (localStorage.getItem('idioma') === 'pt') {
                this.options = [
                    {
                      id: 'Masculino',
                      value: '0'
                    },
                    {
                      id: 'Feminino',
                      value: '1'
                    },
                  ];

                  this.estados = [
                    {
                      id: 'Solteiro',
                      value: '0'
                    },
                    {
                      id: 'Casado',
                      value: '1'
                    },
                    {
                        id: 'Viuvo',
                        value: '2'
                    },
                    {
                        id: 'Divorciado',
                        value: '3'
                    },
                  ];
                this.estudios = [
                    {
                      id: 'Não frequentou a escola e não sabe ler nem escrever',
                      value: '0'
                    },
                    {
                      id: 'Não frequentou a escola, mas sabe ler e escrever',
                      value: '1'
                    },
                    {
                        id: 'Frequentou a escola mas não frequentou o ensino superior',
                        value: '2'
                    },

                  ];
                this.diagnosis = [
                    {
                      id: 'Neoplasias (tumores)',
                      value: '0'
                    },
                    {
                      id: 'Doenças do sangue e desordens do sangue',
                      value: '1'
                    },
                    {
                        id: 'Doenças do sistema nervoso',
                        value: '2'
                    },
                    {
                        id: 'Doenças do sistema circulatório',
                        value: '3'
                    },
                    {
                        id: 'Doenças do trato respiratório',
                        value: '4'
                    },
                    {
                        id: 'Doenças do trato digestivo',
                        value: '5'
                    },
                    {
                        id: 'Afecções dos tecidos capilares e subcutâneos',
                        value: '6'
                    },
                    {
                        id: 'Malformações congênitas, deformidades e anomalias cromossômicas',
                        value: '7'
                    },
                    {
                        id: 'Doenças do sistema musculoesquelético',
                        value: '8'
                    },
                    {
                        id: 'Doenças do aparelho geniturinário',
                        value: '9'
                    },
                    {
                        id: 'Doenças endócrinas, nutricionais e metabólicas',
                        value: '10'
                    },
                    {
                        id: 'Transtornos mentais e comportamento',
                        value: '11'
                    },
                    {
                        id: 'Sem qualquer patologia',
                        value: '12'
                    },

                  ];
            this.estudios1 = [
                {
                    id: 'Frequentou o ensino superior',
                    value: '3'
                }
              ];

            }
            this.ano = new Date().getFullYear();
            this.dateDay = new Date().getDate();
            this.month = new Date().getMonth() + 1;
            this.fecha = this.dateDay + '/' + this.month + '/' + this.ano;
            this.ano1 = new Date().getFullYear();
            this.dateDay1 = new Date().getDate();
            this.month1 = new Date().getMonth() + 1;
            this.fecha1 = this.dateDay1 + '/' + this.month1 + '/' + this.ano1;
        }
    }
  }
  sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    }



    monitoringAgeRelatedDatesChanges() {
        this.evalDateControl.valueChanges.subscribe((value) => {
            if (this.isBirthDateFullfilled() && this.isEvaluationDateFullfilled()) {
                this.ageControl.setValue(this.computeAge(this.birthDateControl.value, this.evalDateControl.value));
             }
        });
        this.birthDateControl.valueChanges.subscribe((value) => {
            if (this.isBirthDateFullfilled() && this.isEvaluationDateFullfilled()) {
                this.ageControl.setValue(this.computeAge(this.birthDateControl.value, this.evalDateControl.value));
             }
        });
    }


    checkAge(birth_date, inputEvaluation_date, inputAge) {
        console.log('checking');
        if (inputEvaluation_date !== undefined && birth_date !== undefined) {
            console.log('computing');
            return this.computeAge(birth_date, inputEvaluation_date);
         }
         return inputAge;
    }


  getPlaces() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getPlaces().subscribe((res) => {
          if (res['errorCode'] > 0) {
              this.error = false;
              this.errorMessage = '';
              this.dataLoading = false;
              this.lugares = res['data'];
          } else {
              this.error = true;
              this.errorMessage = res['errorMessage'];
              this.dataLoading = false;
          }
      },
          (error) => {
              if (error.status === 401 || error.status === 403) {
                  localStorage.setItem('token', '');
                  this._route.navigate(['/login']);
              }
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });
      }

  // reloadRoute(){
  //     window.location.reload();

  // }
  reload() {
  }

  getCitizen() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getCitizen().subscribe((res) => {
          if (res['errorCode'] > 0) {
              this.error = false;
              this.errorMessage = '';
              this.dataLoading = false;
              this.ciudadano = res['data'];

          } else {
              this.error = true;
              this.errorMessage = res['errorMessage'];
              this.dataLoading = false;
          }
      },
          (error) => {
              if (error.status === 401 || error.status === 403) {
                  localStorage.setItem('token', '');
                  this._route.navigate(['/login']);
              }
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });
      }

  getInstitution() {
      this.dataLoading = true;

      this.querySubscription = this.backendService.getInstitution().subscribe((res) => {
          if (res['errorCode'] > 0) {
              this.error = false;
              this.errorMessage = '';
              this.dataLoading = false;
              this.instituciones = res['data'];
              this.institucionesFinal[this.instituciones.length];
              this.institucionesFinal = this.instituciones;
          } else {
              this.error = true;
              this.errorMessage = res['errorMessage'];
              this.dataLoading = false;
          }
          // this.comprobarInstitucion();
      },
          (error) => {
              if (error.status === 401 || error.status === 403) {
                  localStorage.setItem('token', '');
                  this._route.navigate(['/login']);
              }
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });


      }

      /*comprobarInstitucion(){
          console.log("entidad:" + this.usuarioActivo);
          var instituciones_user = this.usuarioActivo.split(',').map(Number);
          console.log("entidad:" + instituciones_user);
          for (let index = 0; index < this.instituciones.length; index++) {
              console.log(this.instituciones[index].number);
              if(this.admin==0){
                  console.log("es admin");
                  this.institucionesFinal[index]=this.instituciones[index];
              } else{
                  if (this.instituciones[index].number==3 || this.instituciones[index].number==4 || this.instituciones[index].number==13){
                      if (instituciones_user.includes(3) || instituciones_user.includes(4) || instituciones_user.includes(13)){
                          console.log("convenio");
                          this.institucionesFinal.push(this.instituciones[index]);
                      }
                  } else{
                      if(instituciones_user.includes(this.instituciones[index].number) && this.admin==1){
                          console.log("include");
                          this.institucionesFinal.push(this.instituciones[index]);
                      }
                  }
              }
          }
          console.log(this.institucionesFinal)
      }*/

    checkEditPatientValues() {

        this.isCollaborator = (window.localStorage.getItem('selected_view') === 'collaborator');

        if (this._paciente == null) {
          this._paciente = {};
          this._paciente.age = '';
          this._paciente.other_diagnosis = '';
          this.editando = false;
        } else {
            if (this.isCollaborator === true) {
                const inputNumber = this._paciente.number;
                this._paciente = {};
                this._paciente.number = inputNumber;
                this._paciente.age = '';
                this._paciente.other_diagnosis = '';
            } else {

                this._paciente.weight = this._paciente.weight === 999 ? undefined : this._paciente.weight;
                this._paciente.height = this._paciente.height === 999 ? undefined : this._paciente.height;
                this._paciente.creation_date = this._paciente.creation_date === '999' ? undefined : this._paciente.creation_date;

                /*We check if in previous version caregiver is not availabled and his data was introduced with default 999 value */
                this._paciente.codigo_caregiver = this._paciente.codigo_caregiver === 999 ? undefined : this._paciente.codigo_caregiver;
                this._paciente.age_caregiver = this._paciente.age_caregiver === 999 ? undefined : this._paciente.age_caregiver;
                this._paciente.gender_caregiver = this._paciente.gender_caregiver === '999' ? undefined : this._paciente.gender_caregiver;
                this._paciente.status_caregiver = this._paciente.status_caregiver === '999' ? undefined : this._paciente.status_caregiver;
                this._paciente.weight_caregiver = this._paciente.weight_caregiver === 999 ? undefined : this._paciente.weight_caregiver;
                this._paciente.height_caregiver = this._paciente.height_caregiver === 999 ? undefined : this._paciente.height_caregiver;
                this._paciente.studies_caregiver = this._paciente.studies_caregiver === 999 ? undefined : this._paciente.studies_caregiver;
                this._paciente.escola_caregiver = this._paciente.escola_caregiver === '999' ? undefined : this._paciente.escola_caregiver;
                this._paciente.diagnosis_available_caregiver = this._paciente.diagnosis_available_caregiver === 999 ? undefined : this._paciente.diagnosis_available_caregiver;
                this._paciente.diagnosis_caregiver = this._paciente.diagnosis_caregiver === 999 ? undefined : this._paciente.diagnosis_caregiver;
                this._paciente.diagnosis2_caregiver = this._paciente.diagnosis2_caregiver === 999 ? undefined : this._paciente.diagnosis2_caregiver;
                this._paciente.diagnosis3_caregiver = this._paciente.diagnosis3_caregiver === 999 ? undefined : this._paciente.diagnosis3_caregiver;
                this._paciente.diagnosis4_caregiver = this._paciente.diagnosis4_caregiver === 999 ? undefined : this._paciente.diagnosis4_caregiver;
                this._paciente.diagnosis5_caregiver = this._paciente.diagnosis5_caregiver === 999 ? undefined : this._paciente.diagnosis5_caregiver;
                this._paciente.diagnosis6_caregiver = this._paciente.diagnosis6_caregiver === 999 ? undefined : this._paciente.diagnosis6_caregiver;
                this._paciente.diagnosis7_caregiver = this._paciente.diagnosis7_caregiver === 999 ? undefined : this._paciente.diagnosis7_caregiver;
                this._paciente.diagnosis8_caregiver = this._paciente.diagnosis8_caregiver === 999 ? undefined : this._paciente.diagnosis8_caregiver;
                this._paciente.diagnosis9_caregiver = this._paciente.diagnosis9_caregiver === 999 ? undefined : this._paciente.diagnosis9_caregiver;
                this._paciente.diagnosis10_caregiver = this._paciente.diagnosis10_caregiver === 999 ? undefined : this._paciente.diagnosis10_caregiver;
                this._paciente.diagnosis11_caregiver = this._paciente.diagnosis11_caregiver === 999 ? undefined : this._paciente.diagnosis11_caregiver;
                this._paciente.diagnosis12_caregiver = this._paciente.diagnosis12_caregiver === 999 ? undefined : this._paciente.diagnosis12_caregiver;
                this._paciente.diagnosis13_caregiver = this._paciente.diagnosis13_caregiver === 999 ? undefined : this._paciente.diagnosis13_caregiver;
                this._paciente.other_diagnosis_caregiver = this._paciente.other_diagnosis_caregiver === 999 ? undefined : this._paciente.other_diagnosis_caregiver;
                this._paciente.conhoce_estatuto = this._paciente.conhoce_estatuto === 999 ? undefined : this._paciente.conhoce_estatuto;
                this._paciente.solicitou_estatuto = this._paciente.solicitou_estatuto === 999 ? undefined : this._paciente.solicitou_estatuto;
                this._paciente.foi_reconhecido = this._paciente.foi_reconhecido === 999 ? undefined : this._paciente.foi_reconhecido;
                this._paciente.en_condicoes_ser_reconhecido = this._paciente.en_condicoes_ser_reconhecido === 999 ? undefined : this._paciente.en_condicoes_ser_reconhecido;
                this._paciente.fora_do_enquadramento_legal = this._paciente.fora_do_enquadramento_legal === 999 ? undefined : this._paciente.fora_do_enquadramento_legal;


                this._paciente.name = this._paciente.name === '999' ? undefined : this._paciente.name;
                this._paciente.birth_date = this._paciente.birth_date === '999' ? undefined : this._paciente.birth_date;
                this._paciente.arterial_tension = this._paciente.arterial_tension === 999 ? undefined : this._paciente.arterial_tension;
                this._paciente.cardiac_frecuency = this._paciente.cardiac_frecuency === 999 ? undefined : this._paciente.cardiac_frecuency;
                this._paciente.respiratory_frecuency = this._paciente.respiratory_frecuency === 999 ? undefined : this._paciente.respiratory_frecuency;
                this._paciente.temperature = this._paciente.temperature === 999 ? undefined : this._paciente.temperature;
                this._paciente.dor = this._paciente.dor === 999 ? undefined : this._paciente.dor;
                this._paciente.pele_integra = this._paciente.pele_integra === 999 ? undefined : this._paciente.pele_integra;
                this._paciente.aguda_cirurgica = this._paciente.aguda_cirurgica === 999 ? undefined : this._paciente.aguda_cirurgica;
                this._paciente.aguda_traumatica = this._paciente.aguda_traumatica === 999 ? undefined : this._paciente.aguda_traumatica;
                this._paciente.complexa_ulcera_pressao = this._paciente.complexa_ulcera_pressao === 999 ? undefined : this._paciente.complexa_ulcera_pressao;
                this._paciente.complexa_queimadura = this._paciente.complexa_queimadura === 999 ? undefined : this._paciente.complexa_queimadura;
                this._paciente.complexa_maligna = this._paciente.complexa_maligna === 999 ? undefined : this._paciente.complexa_maligna;
                this._paciente.complexa_ulcera_perna = this._paciente.complexa_ulcera_perna === 999 ? undefined : this._paciente.complexa_ulcera_perna;
                this._paciente.familia_name = this._paciente.familia_name === '999' ? undefined : this._paciente.familia_name;
                this._paciente.familia_contact = this._paciente.familia_contact === '999' ? undefined : this._paciente.familia_contact;
                this._paciente.visitas = this._paciente.visitas === 999 ? undefined : this._paciente.visitas;
                this._paciente.seidas = this._paciente.seidas === 999 ? undefined : this._paciente.seidas;
                this._paciente.salud = this._paciente.salud === '999' ? undefined : this._paciente.salud;
                this._paciente.medicacion = this._paciente.medicacion === '999' ? undefined : this._paciente.medicacion;
                this._paciente.escola1 = this._paciente.escola1 === '999' ? undefined : this._paciente.escola1;



                if (this._paciente.arterial_tension !== undefined || this._paciente.cardiac_frecuency !== undefined || this._paciente.respiratory_frecuency !== undefined || this._paciente.temperature !== undefined || this._paciente.dor !== undefined) {
                    this._paciente.has_vital = true;
                }

                // //COMMENTED BECAUSE THIS MUST BE FULFILLED EACH TIME A NEW EVALUATION IS CARRIED OUT
                // this._paciente.evaluation_date = this._paciente.evaluation_date==999 ? undefined : this._paciente.evaluation_date;
            }
            this.editando = true;
        }


    }

  insertarCiudadano(formData, inputNumber, inputPlace, inputAge, inputWeight, inputHeight, creation_date, inputAge_caregiver, inputWeight_caregiver, inputHeight_caregiver) {

      formData = this.checkValuesPatient(formData);

      console.log('ENCS-SECCIÓN 1 -----form.component.ts ----PASO POR: insertarCiudadano');
      this.hasError = false;
      this.dataLoading = true;
      this.showError = false;
      if (formData.creation_date instanceof Date) {
          formData.creation_date = this.formatDatePicker(formData.creation_date);
      }
      if (formData.inputEvaluation_date instanceof Date) {
        formData.inputEvaluation_date = this.formatDatePicker(formData.inputEvaluation_date);
      }

    if (formData.birth_date instanceof Date) {
        formData.birth_date = this.formatDatePicker(formData.birth_date);
      }

      formData.inputAge = this._paciente.age;
      formData = this.checkIsInformalCaregiver(formData);
      formData = this.checkVitalSigns(formData);
      formData = this.checkIntegridadePele(formData);
      formData = this.checkFamily(formData);

      formData = this.checkValuesInformalCaregiver(formData, inputAge_caregiver, inputWeight_caregiver, inputHeight_caregiver);

      console.log(formData);
      this.querySubscription = this.backendService.setCiudadano(formData).subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.guardar = true;
            this.dataLoading = false;
            this.savedChanges = true;
            const id_paciente = res['id'];
            const number_paciente = res['number'];
            this.finalizar(id_paciente, number_paciente);
        } else {
            this.error = true;
            this.guardar = false;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
            this.showError = true;

        }
    },
        (error) => {
          if (error.status === 401 || error.status === 403) {
              localStorage.setItem('token', '');
              this._route.navigate(['/login']);
          }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });

  }


  checkValuesPatient(formData) {

    formData.inputWeight = formData.inputWeight == null || formData.inputWeight === undefined || formData.inputWeight === '' ? 999 : formData.inputWeight;
    formData.inputHeight = formData.inputHeight == null || formData.inputHeight === undefined || formData.inputHeight === '' ? 999 : formData.inputHeight;
    formData.creation_date = formData.creation_date == null || formData.creation_date === undefined || formData.creation_date === '' ? 999 : formData.creation_date;

    formData.inputName = formData.inputName === undefined || formData.inputName === '' ? 999 : formData.inputName;
    formData.birth_date = formData.birth_date === undefined || formData.birth_date === '' ? 999 : formData.birth_date;
    formData.arterial_tension = formData.arterial_tension === undefined ? 999 : formData.arterial_tension;
    formData.cardiac_frecuency = formData.cardiac_frecuency === undefined ? 999 : formData.cardiac_frecuency;
    formData.respiratory_frecuency = formData.respiratory_frecuency === undefined ? 999 : formData.respiratory_frecuency;
    formData.temperature = formData.temperature === undefined ? 999 : formData.temperature;
    formData.dor = formData.dor === undefined ? 999 : formData.dor;
    formData.pele_integra = formData.pele_integra === undefined ? 999 : formData.pele_integra;
    formData.aguda_cirurgica = formData.aguda_cirurgica === undefined ? 999 : formData.aguda_cirurgica;
    formData.aguda_traumatica = formData.aguda_traumatica === undefined ? 999 : formData.aguda_traumatica;
    formData.complexa_ulcera_pressao = formData.complexa_ulcera_pressao === undefined ? 999 : formData.complexa_ulcera_pressao;
    formData.complexa_queimadura = formData.complexa_queimadura === undefined ? 999 : formData.complexa_queimadura;
    formData.complexa_maligna = formData.complexa_maligna === undefined ? 999 : formData.complexa_maligna;
    formData.complexa_ulcera_perna = formData.complexa_ulcera_perna === undefined ? 999 : formData.complexa_ulcera_perna;
    formData.familia_name = formData.familia_name === undefined || formData.familia_name === '' ? 999 : formData.familia_name;
    formData.familia_contact = formData.familia_contact === undefined || formData.familia_contact === '' ? 999 : formData.familia_contact;
    formData.visitas = formData.visitas === undefined ? 999 : formData.visitas;
    formData.seidas = formData.seidas === undefined ? 999 : formData.seidas;
    formData.salud = formData.salud === undefined ? 999 : formData.salud;
    formData.medicacion = formData.medicacion === undefined ? 999 : formData.medicacion;
    formData.escola1 = formData.escola1 === undefined ? 999 : formData.escola1;

    return formData;
  }


  isBirthDateFullfilled() {
      /*if(this._paciente.birth_date!=undefined) {*/
    if (this.birthDateControl.value !== undefined) {
          return true;
      } else {
          return false;
      }
  }

  isEvaluationDateFullfilled() {
    /*if(this.fecha!=undefined) {*/
        if (this.evalDateControl.value !== undefined) {
        return true;
    } else {
        return false;
    }
  }


  isDateFullfilled(date) {
      if (date !== undefined) {
          return true;
      }
      return false;
  }
  computeAge(birth_date, evaluation_date) {
    console.log('computing');

    if (this.isDateFullfilled(birth_date) && this.isDateFullfilled(evaluation_date)) {
        const date_evaluation_date = new Date(evaluation_date);
        const date_birth_date = new Date(birth_date);
        const timeDiff = Math.abs(date_evaluation_date.getTime() - date_birth_date.getTime());
        const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
        this._paciente.age = age;
        return age;
    } else {
        return 0;
    }

  }

  checkCodeCaregiver() {
      this._paciente.inputCode_caregiver = String(this._paciente.inputCode) + 'CUID';
  }

  checkIsInformalCaregiver(data) {
    if (data.has_informal_caregiver !== 1 && data.has_informal_caregiver !== true) {
        data.has_informal_caregiver = 0;
        data.inputCode_caregiver = 999;
        data.inputAge_caregiver = 999;
        data.radio_caregiver = 999;
        data.optionsestado_caregiver = 999;
        data.inputWeight_caregiver = 999;
        data.inputHeight_caregiver = 999;
        data.optionestudios_caregiver = 999;
        data.escola_caregiver = 999;
        data.diagnosis_available_caregiver = 999;
        data.diagnosis_caregiver = 999;
        data.diagnosis2_caregiver = 999;
        data.diagnosis3_caregiver = 999;
        data.diagnosis4_caregiver = 999;
        data.diagnosis5_caregiver = 999;
        data.diagnosis6_caregiver = 999;
        data.diagnosis7_caregiver = 999;
        data.diagnosis8_caregiver = 999;
        data.diagnosis9_caregiver = 999;
        data.diagnosis10_caregiver = 999;
        data.diagnosis11_caregiver = 999;
        data.diagnosis12_caregiver = 999;
        data.diagnosis13_caregiver = 999;
        data.other_diagnosis_caregiver = 999;
        data.conhoce_estatuto = 999;
        data.solicitou_estatuto = 999;
        data.foi_reconhecido = 999;
        data.en_condicoes_ser_reconhecido = 999;
        data.fora_do_enquadramento_legal = 999;
    } else {
        data.inputCode_caregiver = String(data.inputNumber) + 'CUID';
    }

    return data;
  }


    checkVitalSigns(data) {
        console.log('En checkVitalSigns');
        console.log(data);
        if (data.has_vital !== 1 && data.has_vital !== true) {
            data.arterial_tension = 999;
            data.cardiac_frecuency = 999;
            data.respiratory_frecuency = 999;
            data.temperature = 999;
            data.dor = 999;
        } else {
            data.arterial_tension = data.arterial_tension === undefined || data.arterial_tension === '' ? 999 : data.arterial_tension;
            data.cardiac_frecuency = data.cardiac_frecuency === undefined || data.cardiac_frecuency === '' ? 999 : data.cardiac_frecuency;
            data.respiratory_frecuency = data.respiratory_frecuency === undefined || data.respiratory_frecuency === '' ? 999 : data.respiratory_frecuency;
            data.temperature = data.temperature === undefined || data.temperature === '' ? 999 : data.temperature;
            data.dor = data.dor === undefined || data.dor === '' ? 999 : data.dor;
        }

        return data;
    }

    checkIntegridadePele(data) {
        if (data.pele_integra !== 0) {
            data.aguda_cirurgica = 999;
            data.aguda_traumatica = 999;
            data.complexa_ulcera_pressao = 999;
            data.complexa_queimadura = 999;
            data.complexa_maligna = 999;
            data.complexa_ulcera_perna = 999;
        } else {
            data.aguda_cirurgica = data.aguda_cirurgica === undefined || data.aguda_cirurgica === '' ? 0 : data.aguda_cirurgica;
            data.aguda_traumatica = data.aguda_traumatica === undefined || data.aguda_traumatica === '' ? 0 : data.aguda_traumatica;
            data.complexa_ulcera_pressao = data.complexa_ulcera_pressao === undefined || data.complexa_ulcera_pressao === '' ? 0 : data.complexa_ulcera_pressao;
            data.complexa_queimadura = data.complexa_queimadura === undefined || data.complexa_queimadura === '' ? 0 : data.complexa_queimadura;
            data.complexa_maligna = data.complexa_maligna === undefined || data.complexa_maligna === '' ? 0 : data.complexa_maligna;
            data.complexa_ulcera_perna = data.complexa_ulcera_perna === undefined || data.complexa_ulcera_perna === '' ? 0 : data.complexa_ulcera_perna;
        }

        return data;
    }

    checkFamily(data) {

        data.familia_name = data.familia_name === undefined || data.familia_name === '' ? 999 : data.familia_name;
        data.familia_contact = data.familia_contact === undefined || data.familia_contact === '' ? 999 : data.familia_contact;
        data.visitas = data.visitas === undefined || data.visitas === '' ? 999 : data.visitas;
        data.seidas = data.seidas === undefined || data.seidas === '' ? 999 : data.seidas;

        return data;
    }


  checkValuesInformalCaregiver(formData, inputAge_caregiver, inputWeight_caregiver, inputHeight_caregiver) {

    formData.conhoce_estatuto = formData.conhoce_estatuto === undefined || formData.conhoce_estatuto === '' ? 999 : formData.conhoce_estatuto;
    formData.solicitou_estatuto = formData.solicitou_estatuto === undefined || formData.solicitou_estatuto === '' ? 999 : formData.solicitou_estatuto;
    formData.foi_reconhecido = formData.foi_reconhecido === undefined || formData.foi_reconhecido === '' ? 999 : formData.foi_reconhecido;
    formData.en_condicoes_ser_reconhecido = formData.en_condicoes_ser_reconhecido === undefined || formData.en_condicoes_ser_reconhecido === '' ? 999 : formData.en_condicoes_ser_reconhecido;
    formData.fora_do_enquadramento_legal = formData.fora_do_enquadramento_legal === undefined || formData.fora_do_enquadramento_legal === '' ? 999 : formData.fora_do_enquadramento_legal;


    if (inputWeight_caregiver.value == null || inputWeight_caregiver.value === '' ) {
        console.log('weight es nulo');
        formData.inputWeight_caregiver = 999;
    }
    if (inputHeight_caregiver.value == null || inputHeight_caregiver.value === '') {
        console.log('height es nulo');
        formData.inputHeight_caregiver = 999;
    }
    return formData;
  }

  formatDatePicker(date: Date) {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
  }

 /* findIDCiudadano(id){
      this.dataLoading = true;
      this.querySubscription = this.backendService.findIDCiudadano(id).subscribe((res) => {
          if (res["errorCode"] > 0) {
              this.error = false;
              this.errorMessage = "";
              this.dataLoading = false;
              this.savedChanges = true;
          } else {
              this.error = true;
              this.errorMessage = res["errorMessage"];
              this.dataLoading = false;
          }
      },
          (error) => {
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });
  }

*/

  enviar() {
    console.log('TEST');
    console.log(this._paciente);
    console.log(this.original);
  }


  ngOnDestroy() {
      if (this.querySubscription) {
        this.querySubscription.unsubscribe();
        this.institucionesFinal = [];
      }
  }


  checkDiagnosisIsValid(): boolean {
        if (this._paciente.diagnosis_available === 1) {
            console.log('Diagnosis disponible');
            console.log(this._paciente);
            if (this._paciente.diagnosis === 1 || this._paciente.diagnosis1 === 1 || this._paciente.diagnosis2 === 1 || this._paciente.diagnosis3 === 1 || this._paciente.diagnosis4 === 1 || this._paciente.diagnosis5 === 1 || this._paciente.diagnosis6 === 1 ||
                this._paciente.diagnosis7 === 1 || this._paciente.diagnosis8 === 1 || this._paciente.diagnosis9 === 1 || this._paciente.diagnosis10 === 1 || this._paciente.diagnosis11 === 1 || this._paciente.diagnosis12 === 1 || this._paciente.diagnosis13 === 1 ||
                this._paciente.other_diagnosis.trim() !== '') {
                    this.checkDiagnosisFields = false;
                    return true;
            }
            this.checkDiagnosisFields = true;
            return false;
        } else {
            this.unCheckDiagnosis();
            this.checkDiagnosisFields = false;
            return true;
        }
  }


  checkDiagnosisCaregiverIsValid(): boolean {
    if ((this._paciente.has_informal_caregiver === 1 || this._paciente.has_informal_caregiver === true) && this._paciente.diagnosis_available_caregiver === 1) {
        console.log('Diagnosis caregiver disponible');
        console.log(this._paciente);
        if (this._paciente.diagnosis_caregiver === 1 || this._paciente.diagnosis1_caregiver === 1 || this._paciente.diagnosis2_caregiver === 1 || this._paciente.diagnosis3_caregiver === 1 || this._paciente.diagnosis4_caregiver === 1 ||
            this._paciente.diagnosis5_caregiver === 1 || this._paciente.diagnosis6_caregiver === 1 || this._paciente.diagnosis7_caregiver === 1 || this._paciente.diagnosis8_caregiver === 1 || this._paciente.diagnosis9_caregiver === 1 ||
            this._paciente.diagnosis10_caregiver === 1 || this._paciente.diagnosis11_caregiver === 1 || this._paciente.diagnosis12_caregiver === 1 || this._paciente.diagnosis13_caregiver === 1 || this._paciente.other_diagnosis_caregiver.trim() !== '') {
                this.checkDiagnosisCaregiverFields = false;
                return true;
        }
        this.checkDiagnosisCaregiverFields = true;
        return false;
    } else {
        this.unCheckDiagnosisCaregiver();
        this.checkDiagnosisCaregiverFields = false;
        return true;
    }
}

  unCheckDiagnosis() {
    this._paciente.diagnosis = 0;
    this._paciente.diagnosis1 = 0;
    this._paciente.diagnosis2 = 0;
    this._paciente.diagnosis3 = 0;
    this._paciente.diagnosis4 = 0;
    this._paciente.diagnosis5 = 0;
    this._paciente.diagnosis6 = 0;
    this._paciente.diagnosis7 = 0;
    this._paciente.diagnosis8 = 0;
    this._paciente.diagnosis9 = 0;
    this._paciente.diagnosis10 = 0;
    this._paciente.diagnosis11 = 0;
    this._paciente.diagnosis12 = 0;
    this._paciente.diagnosis13 = 0;
  }

  unCheckDiagnosisCaregiver() {
    this._paciente.diagnosis_caregiver = 0;
    this._paciente.diagnosis1_caregiver = 0;
    this._paciente.diagnosis2_caregiver = 0;
    this._paciente.diagnosis3_caregiver = 0;
    this._paciente.diagnosis4_caregiver = 0;
    this._paciente.diagnosis5_caregiver = 0;
    this._paciente.diagnosis6_caregiver = 0;
    this._paciente.diagnosis7_caregiver = 0;
    this._paciente.diagnosis8_caregiver = 0;
    this._paciente.diagnosis9_caregiver = 0;
    this._paciente.diagnosis10_caregiver = 0;
    this._paciente.diagnosis11_caregiver = 0;
    this._paciente.diagnosis12_caregiver = 0;
    this._paciente.diagnosis13_caregiver = 0;
  }



  checkVitalSignsIsValid() {
      console.log('En checkVitalSignsIsValid');
      console.log(this._paciente.has_vital);
    if (this._paciente.has_vital === 1 || this._paciente.has_vital === true) {
        console.log(this._paciente);
        if (this._paciente.arterial_tension !== 0 || this._paciente.cardiac_frecuency !== 0  || this._paciente.respiratory_frecuency !== 0  || this._paciente.temperature !== 0  || this._paciente.dor !== 0 ) {
                this.checkVitalSignsFields = false;
                return true;
        }
        this.checkVitalSignsFields = true;
        return false;
    } else {
        this.unCheckVitalSigns();
        this.checkVitalSignsFields = false;
        return true;
    }
  }

  unCheckVitalSigns() {
    this._paciente.arterial_tension = undefined;
    this._paciente.cardiac_frecuency = undefined;
    this._paciente.respiratory_frecuency = undefined;
    this._paciente.temperature = undefined;
    this._paciente.dor = undefined;
  }

  checkIntegridadePeleIsValid() {
    if (this._paciente.pele_integra === 0) {


        console.log(this._paciente);
        if (this._paciente.aguda_cirurgica === true || this._paciente.aguda_traumatica === true || this._paciente.complexa_ulcera_pressao === true || this._paciente.complexa_queimadura === true || this._paciente.complexa_maligna === true || this._paciente.complexa_ulcera_perna === true) {
                this.checkIntegridadePeleFields = false;
                return true;
        }
        this.checkIntegridadePeleFields = true;
        return false;
    }
    this.unCheckIntegridadePele();
    this.checkIntegridadePeleFields = false;
    return true;
  }



  unCheckIntegridadePele() {
    this._paciente.aguda_cirurgica = 0;
    this._paciente.aguda_traumatica = 0;
    this._paciente.complexa_ulcera_pressao = 0;
    this._paciente.complexa_queimadura = 0;
    this._paciente.complexa_maligna = 0;
    this._paciente.complexa_ulcera_perna = 0;
  }
}
